<template>
  <v-dialog :model-value="show" @update:model-value="$emit('update:show', $event)" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Node Derivation Rule</span>
      </v-card-title>
      <v-card-text>
        <p>This node was generated by the following rule:</p>
        <pre v-if="rule" class="rule-json">{{ JSON.stringify(rule, null, 2) }}</pre>
        <p v-else>This node does not have a specific derivation rule (it may be a raw backend node or a manually created one without a rule attached).</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('update:show', false)">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RuleInspectorDialog',
  props: {
    show: { type: Boolean, required: true },
    rule: { type: Object, default: null },
  },
  emits: ['update:show'],
};
</script>

<style scoped>
.rule-json {
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
  margin-top: 1rem;
}
</style>